<template>
  <el-dialog
    title=""
    customClass="payDialog"
    :visible.sync="payDialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :append-to-body="true"
    :modal-append-to-body="true"
  >
    <div class="title">请扫码支付</div>
    <div class="qrCode">
      <div class="img" id="qrcode"></div>
    </div>
    <div class="pay-way">
      <img src="@/assets/images/wx-pay.png" alt="" />
      <span>微信</span>
      <img class="ml20" src="@/assets/images/ali-pay.png" alt="" />
      <span>支付宝</span>
      <img class="ml20" src="@/assets/images/yun-pay.png" alt="" />
      <span>云闪付</span>
    </div>
    <div class="footer-btn">
      <div @click="handleClose">取消</div>
    </div>
  </el-dialog>
</template>

<script>
import { payConfirm, orderInfo, uniteOrderInfo, cancelOrder } from '@/api/pay'
import QRCode from 'qrcodejs2'
export default {
  name: 'PayDialog',
  data () {
    return {
      payDialogVisible: false,
      payLoading: null
    }
  },
  props: ['from'],
  methods: {
    handleClose () {
      this.payDialogVisible = false
      this.payLoading.close()
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.$router.push({
        path: '/payFailed',
        query: {
          orderNo: this.orderNo,
          moduleType: this.moduleType,
          t: Date.now(),
          from: this.from
        }
      })
    },
    handleCancel () {
      this.payDialogVisible = false
      this.payLoading.close()
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.cancelOrder(this.orderNo, this.moduleType)
    },
    cancelOrder (orderNo, moduleType) {
      this.orderNo = orderNo
      this.moduleType = moduleType
      const data = {
        orderNo: this.orderNo
      }
      // this.payLoading = this.$loading({
      //   lock: true,
      //   text: '请稍等',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      cancelOrder(data, this.moduleType).then(res => {
        if (res.code === 0) {
          this.$router.push({
            path: '/paySucceed',
            query: { moduleType: this.moduleType, status: 'cancel' }
          })
        } else {
          // this.payLoading.close()
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    toPay (orderNo, moduleType) {
      this.orderNo = orderNo
      this.moduleType = moduleType
      const data = {
        orderNo: this.orderNo
      }
      this.payLoading = this.$loading({
        lock: true,
        text: '请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      payConfirm(data, this.moduleType, this.from).then(res => {
        if (res.code === 0) {
          if (res.data.payStatus === 'PAID') {
            this.$router.push({
              path: '/paySucceed',
              query: { moduleType: this.moduleType, status: 'success' }
            })
            this.payLoading.close()
            return
          }
          this.payDialogVisible = true
          this.$nextTick(() => {
            if (this.payDialogVisible) {
              const obj = JSON.parse(res.data.payInfo)
              document.getElementById('qrcode').innerHTML = ''
              this.qrcode = new QRCode('qrcode', {
                width: 240,
                height: 240,
                text: obj.qrCode || obj.oneQRForAll,
                // 处理二维码文字过长问题
                correctLevel: QRCode.CorrectLevel.Q
              })
              this.payLoading.close()
            }
          })
          if (this.timer) {
            clearInterval(this.timer)
          }
          this.timer = setInterval(async () => {
            let r = null
            if (this.from === 'cart') {
              r = await uniteOrderInfo(this.orderNo)
            } else {
              r = await orderInfo(this.orderNo, this.moduleType)
            }
            if (r.code === 0) {
              if (this.from === 'cart') r.data = r.data[0]
              if (Number(r.data.status) === 10 || Number(r.data.status) === 6) {
                this.payLoading.close()
                clearInterval(this.timer)
                this.$router.push({
                  path: '/paySucceed',
                  query: { moduleType: this.moduleType, status: 'success' }
                })
              } else {
                if (Number(r.data.status) !== 0 && Number(r.data.status) !== 1) {
                  clearInterval(this.timer)
                  this.payLoading.close()
                  this.$router.push({
                    path: '/payFailed',
                    query: {
                      orderNo: this.orderNo,
                      moduleType: this.moduleType,
                      t: Date.now()
                    }
                  })
                }
              }
            } else {
              this.payLoading.close()
              this.$message({
                message: res.error,
                type: 'error'
              })
            }
          }, 2000)
        } else {
          this.payLoading.close()
          this.$message({
            message: res.error,
            type: 'error'
          })
          setTimeout(() => {
            this.$router.push({
              path: '/payFailed',
              query: {
                orderNo: this.orderNo,
                moduleType: this.moduleType,
                t: Date.now(),
                from: this.from
              }
            })
          }, 1000)
        }
      })
    }
  }
}
</script>
<style lang="scss">
.payDialog{
  width: 440px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px rgba(14, 78, 114, 0.08);
  opacity: 1;
  border-radius: 16px;
  .title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 21px;
    color: #A0393E;
    text-align: center;
    margin-bottom: 48px;
  }
  .qrCode{
    padding: 0;
    .img{
      width: 240px;
      height: 240px;
    }
  }
  .footer-btn{
    width: 340px;
    height: 44px;
    background: #A0393E;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    line-height: 44px;
    color: #FFFFFF;
    text-align: center;
    margin: 48px auto 10px auto;
  }
  .pay-way {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    img {
      margin-right: 6px;
      width: 45px;
    }
  }
}
</style>
